import { RegItem } from 'src/types/regItem'
import { RegItemCategory } from 'src/types/regItemCategory'
import { AppliedSortsAndFilters } from '../RegistryGiftGiverPage/RegistryGiftGiverPage.types'
import { RegItemCategoryAugmented } from './RegistryCategories.types'

const MOST_WANTED_FAKE_CATEGORY_ID = Number.MIN_SAFE_INTEGER

interface getCategorizedRegItemsParams {
  categories: RegItemCategory[]
  regItems: Partial<RegItem>[]
  appliedSortsAndFilters: AppliedSortsAndFilters
}

export const getCategorizedRegItems = ({
  categories = [],
  regItems = [],
  appliedSortsAndFilters,
}: getCategorizedRegItemsParams): RegItemCategoryAugmented[] => {
  const regItemsByCategoryId: Record<string, RegItem[]> =
    groupRegItemsByCategory(regItems, appliedSortsAndFilters)

  const sortedCategories = sortCategories(categories)

  const augmentedCategories: RegItemCategoryAugmented[] =
    getAugmentedCategories(sortedCategories, regItemsByCategoryId)

  return augmentedCategories
}

const groupRegItemsByCategory = (
  regItems: Partial<RegItem>[],
  appliedSortsAndFilters: AppliedSortsAndFilters
) => {
  const categoryFilter = appliedSortsAndFilters.filters?.category
  const shouldIncludeMostWantedFakeCategory =
    categoryFilter === 'All' || categoryFilter === 'Most wanted'

  // TODO: Remove ts-ignore once we are on newer version of TS (v5.4) which recognizes groupBy
  // @ts-ignore
  return Object.groupBy(regItems, (regItem: RegItem) => {
    if (shouldIncludeMostWantedFakeCategory && regItem.isFavorite) {
      return MOST_WANTED_FAKE_CATEGORY_ID
    }

    return regItem.categoryId
  })
}

const sortCategories = (categories: RegItemCategory[]) =>
  [
    {
      id: MOST_WANTED_FAKE_CATEGORY_ID,
      title: 'Most wanted',
      position: MOST_WANTED_FAKE_CATEGORY_ID,
    },
    ...categories,
  ].sort((a, b) => a.position - b.position)

const getAugmentedCategories = (
  sortedCategories: RegItemCategory[],
  regItemsByCategoryId: Record<string, RegItem[]>
) =>
  sortedCategories
    .map((category) => ({
      category,
      items: regItemsByCategoryId[category.id || 0] || [],
    }))
    .filter(({ items }) => Array.isArray(items) && items.length > 0)
